import {memo} from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Box, Divider, Flex } from '@chakra-ui/react'
import DsrCreatePostTypeButton from '../../dsr-create-post/DsrCreatePostTypeButton';
import { BiEditAlt } from 'react-icons/bi';


function PublicDsrCreatePostDecoy({ handleOpenSignupOrLoginModal, isMobileView }) {

  return (
    <>
      <Box p='1em' w='100%' bg='white' rounded='0.25em' border='1px solid' borderColor='gray.300'>
        <Flex mt='0.625em' justify='flex-start' width='100%' px={['0','1em']}>
          <Flex
            px='0.5em'
            width='100%'
            border='1px solid' borderColor='gray.400' rounded='0.25em'
            cursor='pointer'
            gap='0.5em'
            align='center'
            onClick={() => handleOpenSignupOrLoginModal()}>
            <Box as={BiEditAlt} color='gray.500' boxSize="1em" />
            <Box color='gray.500' py='0.5em' fontSize='0.9em'>What are you thinking about?</Box>
          </Flex>
        </Flex>
        {isMobileView ?
          <Flex justify='space-between' align='center'>
            <Flex gap='20px' my='1em' mt='1.5em' width='100%' justifyContent='space-around' flexWrap='wrap'>
              <DsrCreatePostTypeButton isProductMarketing={true} type='write-post' handleOpenSignupOrLoginModal={handleOpenSignupOrLoginModal} />
              <DsrCreatePostTypeButton isProductMarketing={true} type='ask-question' handleOpenSignupOrLoginModal={handleOpenSignupOrLoginModal} />
            </Flex>
          </Flex>
          :
          <Flex justify='space-between' align='center'>
            <Flex gap='20px' my='1em' mt='1.5em' width='100%' justifyContent='space-between' flexWrap='wrap'>
              <DsrCreatePostTypeButton isProductMarketing={true} type='write-post' handleOpenSignupOrLoginModal={handleOpenSignupOrLoginModal} />
              <DsrCreatePostTypeButton isProductMarketing={true} type='ask-question' handleOpenSignupOrLoginModal={handleOpenSignupOrLoginModal} />
              <DsrCreatePostTypeButton isProductMarketing={true} type='record-loom-video-decoy' handleOpenSignupOrLoginModal={handleOpenSignupOrLoginModal} />
              <DsrCreatePostTypeButton isProductMarketing={true} type='create-action-item-decoy' handleOpenSignupOrLoginModal={handleOpenSignupOrLoginModal} />
            </Flex>
          </Flex>
        }
      </Box>

      <Box mt='1.5em' mb='0.5em'>
        <Divider />
      </Box>
    </>
  );

}

const mapStateToProps = (state) => ({
  isMobileView: state.mobileViewMode.isMobileView
})

export default memo(withRouter(connect(mapStateToProps, null)(PublicDsrCreatePostDecoy)))
